import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-form-navigation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './form-navigation.component.html',
  styleUrls: ['./form-navigation.component.scss']
})
export class FormNavigationComponent {
  @Input() currentStep: number = 1;
  @Input() showComprobante: boolean = false;
  @Input() allDocumentsSigned: boolean = false;
  @Input() aceptacionFinal: boolean = false;

  @Output() previous = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Output() openModal = new EventEmitter<void>();

  get isStep6Disabled(): boolean {
    return this.currentStep === 6 && (!this.allDocumentsSigned || !this.aceptacionFinal);
  }

  getNextButtonText(): string {
    if (this.currentStep === 6) return 'Finalizar';
    if (this.currentStep === 5) return 'Siguiente';
    return 'Siguiente paso';
  }

  handleNextClick() {
    if (this.currentStep === 1) {
      this.openModal.emit();
    } else {
      this.next.emit();
    }
  }

  handleConvencidoClick() {
    window.open(
      'https://www.unipay.cl/api/descargaArchivo/20240731_unipay_informativo.jpg',
      '_blank',
      'noopener,noreferrer',
    );
  }
}
